// 古いデモ入力（saved）を、いまのフォーム（defaults = 空のフォーム）に合わせて取り込む。
// デモにはバージョン管理が無いので、項目が増減・改名・型変更されていても壊れないよう、
// defaults にあるキーだけを、型が一致するときだけ採用する
export const mergeDemoInput = (saved, defaults) => {
  const result = {};
  for (const key of Object.keys(defaults)) {
    result[key] = pickValidValue(saved?.[key], defaults[key], key);
  }
  return result;
};

// xxx_id は選択元（<select>は文字列、オートコンプリートAPIの id は数値）によって
// 型が変わるため、値の有無だけ見る。それ以外は型が変わっていたら defaults のまま
const isIdKey = (key) => key.endsWith("_id");

const pickValidValue = (savedValue, defaultValue, key) => {
  if (Array.isArray(defaultValue)) {
    if (!Array.isArray(savedValue)) return defaultValue;

    const rowDefaults = defaultValue[0];
    const isObjectRow =
      rowDefaults &&
      typeof rowDefaults === "object" &&
      !Array.isArray(rowDefaults);
    if (!isObjectRow) return savedValue;

    // オブジェクトの配列（工程・言語など）は各行も同じルールで整える
    const rows = savedValue
      .filter((row) => row && typeof row === "object" && !Array.isArray(row))
      .map((row) => mergeDemoInput(row, rowDefaults));
    return rows.length ? rows : defaultValue;
  }

  if (isIdKey(key)) {
    const isScalar = typeof savedValue === "string" || typeof savedValue === "number";
    return isScalar ? savedValue : defaultValue;
  }

  return typeof savedValue === typeof defaultValue ? savedValue : defaultValue;
};
